var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate1Focus2Right(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1293 39.5455V57H56.4872V42.1875H56.3849L52.2088 44.9148V42.392L56.5639 39.5455H59.1293Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 82,
    width: 32,
    height: 79,
    rx: 5,
    transform: "rotate(-90 101 82)",
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 82,
    width: 32,
    height: 79,
    rx: 5,
    transform: "rotate(-90 101 82)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 46,
    width: 31,
    height: 79,
    rx: 5,
    transform: "rotate(-90 101 46)",
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 46,
    width: 31,
    height: 79,
    rx: 5,
    transform: "rotate(-90 101 46)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.82 39V37.0909L140.726 30.9716C141.357 30.3068 141.876 29.7244 142.286 29.2244C142.7 28.7187 143.01 28.2386 143.214 27.7841C143.419 27.3295 143.521 26.8466 143.521 26.3352C143.521 25.7557 143.385 25.2557 143.112 24.8352C142.839 24.4091 142.467 24.0824 141.996 23.8551C141.524 23.6222 140.993 23.5057 140.402 23.5057C139.777 23.5057 139.232 23.6335 138.766 23.8892C138.3 24.1449 137.942 24.5057 137.692 24.9716C137.442 25.4375 137.317 25.983 137.317 26.608H134.803C134.803 25.5455 135.047 24.6165 135.536 23.821C136.024 23.0256 136.695 22.4091 137.547 21.9716C138.399 21.5284 139.368 21.3068 140.453 21.3068C141.55 21.3068 142.516 21.5256 143.351 21.9631C144.192 22.3949 144.848 22.9858 145.32 23.7358C145.791 24.4801 146.027 25.321 146.027 26.2585C146.027 26.9062 145.905 27.5398 145.661 28.1591C145.422 28.7784 145.004 29.4687 144.408 30.2301C143.811 30.9858 142.982 31.9034 141.919 32.983L138.45 36.6136V36.7415H146.308V39H134.82Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.521 75.2386C139.351 75.2386 138.305 75.0369 137.385 74.6335C136.47 74.2301 135.746 73.6705 135.212 72.9545C134.683 72.233 134.399 71.3977 134.359 70.4489H137.036C137.07 70.9659 137.243 71.4148 137.555 71.7955C137.874 72.1705 138.288 72.4602 138.8 72.6648C139.311 72.8693 139.879 72.9716 140.504 72.9716C141.192 72.9716 141.8 72.8523 142.328 72.6136C142.862 72.375 143.28 72.0426 143.581 71.6165C143.882 71.1847 144.033 70.6875 144.033 70.125C144.033 69.5398 143.882 69.0256 143.581 68.5824C143.286 68.1335 142.851 67.7812 142.277 67.5256C141.709 67.2699 141.021 67.142 140.214 67.142H138.74V64.9943H140.214C140.862 64.9943 141.43 64.8778 141.919 64.6449C142.413 64.4119 142.8 64.0881 143.078 63.6733C143.357 63.2528 143.496 62.7614 143.496 62.1989C143.496 61.6591 143.374 61.1903 143.129 60.7926C142.891 60.3892 142.55 60.0739 142.107 59.8466C141.669 59.6193 141.152 59.5057 140.555 59.5057C139.987 59.5057 139.456 59.6108 138.962 59.821C138.473 60.0256 138.075 60.321 137.768 60.7074C137.462 61.0881 137.297 61.5455 137.274 62.0795H134.726C134.754 61.1364 135.033 60.3068 135.561 59.5909C136.095 58.875 136.8 58.3153 137.675 57.9119C138.55 57.5085 139.521 57.3068 140.589 57.3068C141.709 57.3068 142.675 57.5256 143.487 57.9631C144.305 58.3949 144.936 58.9716 145.379 59.6932C145.828 60.4148 146.05 61.2045 146.044 62.0625C146.05 63.0398 145.777 63.8693 145.226 64.5511C144.68 65.233 143.953 65.6903 143.044 65.9233V66.0597C144.203 66.2358 145.101 66.696 145.737 67.4403C146.379 68.1847 146.697 69.108 146.692 70.2102C146.697 71.1705 146.43 72.0312 145.891 72.7926C145.357 73.554 144.626 74.1534 143.7 74.5909C142.774 75.0227 141.714 75.2386 140.521 75.2386Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_137"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate1Focus2Right);
export default __webpack_public_path__ + "static/media/template_1focus_2right.a2af8c9ffd761b60598cd765737ba2db.svg";
export { ForwardRef as ReactComponent };